import { NgModule } from '@angular/core';
import { FeatureFlagDirective } from './feature-flag.directive';

@NgModule({
  imports: [],
  declarations: [FeatureFlagDirective],
  exports: [FeatureFlagDirective]
})
export class FeatureFlagModule { }


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/feature-flag/feature-flag.module.ts